"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var lodash_1 = require("lodash");

var Procedure_1 = require("./Procedure");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");
/**
 * Procedure that revokes KYC for a list of investors
 */


var RevokeKyc =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(RevokeKyc, _Procedure_1$Procedur);

  function RevokeKyc() {
    var _this;

    _classCallCheck(this, RevokeKyc);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RevokeKyc).apply(this, arguments));
    _this.type = types_1.ProcedureType.RevokeKyc;
    return _this;
  }
  /**
   * Sets all KYC dates for a tokenholder to epoch. This effectively makes them unable to send or receive Security Tokens
   *
   * Note that this procedure will fail if:
   * - The tokenholder address array is empty
   * - The Security Token doesn't exist
   * - KYC is already revoked for at least one of the addresses in the list
   * - Tokenholders Feature isn't enabled
   */


  _createClass(RevokeKyc, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var _this$args, symbol, tokenholderAddresses, _this$context, contractWrappers, factories, securityToken, tokenholders, currentNonRevokedTokenholderAddresses, diff, gtmModule, canSendAfter, canReceiveAfter, expiryTime, securityTokenId, _ref2, _ref3, revokedTokenholders;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$args = this.args, symbol = _this$args.symbol, tokenholderAddresses = _this$args.tokenholderAddresses;
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, factories = _this$context.factories;

                if (!(tokenholderAddresses.length === 0)) {
                  _context2.next = 4;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: 'You must provide at least one tokenholder address to revoke KYC for'
                });

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](4);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 12:
                _context2.next = 14;
                return factories.securityTokenFactory.fetch(entities_1.SecurityToken.generateId({
                  symbol: symbol
                }));

              case 14:
                securityToken = _context2.sent;
                _context2.next = 17;
                return securityToken.tokenholders.getTokenholders();

              case 17:
                tokenholders = _context2.sent;
                currentNonRevokedTokenholderAddresses = tokenholders.filter(function (tokenholder) {
                  return !tokenholder.isRevoked();
                }).map(function (_ref) {
                  var address = _ref.address;
                  return address;
                });
                diff = lodash_1.difference(tokenholderAddresses, currentNonRevokedTokenholderAddresses);

                if (!diff.length) {
                  _context2.next = 22;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.ProcedureValidationError,
                  message: "\"".concat(diff.join(', '), "\" already revoked")
                });

              case 22:
                _context2.next = 24;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.GeneralTransferManager,
                  symbol: symbol
                }, {
                  unarchived: true
                });

              case 24:
                gtmModule = _context2.sent[0];

                if (gtmModule) {
                  _context2.next = 27;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FatalError,
                  message: "General Transfer Manager for token \"".concat(symbol, "\" isn't enabled. Please report this issue to the Polymath team")
                });

              case 27:
                canSendAfter = [];
                canReceiveAfter = [];
                expiryTime = [];
                tokenholderAddresses.forEach(function () {
                  canSendAfter.push(new Date(0));
                  canReceiveAfter.push(new Date(0));
                  expiryTime.push(new Date(0));
                });
                securityTokenId = entities_1.SecurityToken.generateId({
                  symbol: symbol
                });
                _context2.next = 34;
                return this.addTransaction(gtmModule.modifyKYCDataMulti, {
                  tag: types_1.PolyTransactionTag.ModifyKycDataMulti,
                  resolvers: [function () {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee() {
                      var refreshingTokenholders, fetchingTokenholders;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              refreshingTokenholders = tokenholderAddresses.map(function (tokenholder) {
                                return factories.tokenholderFactory.refresh(entities_1.Tokenholder.generateId({
                                  securityTokenId: securityTokenId,
                                  address: tokenholder
                                }));
                              });
                              _context.next = 3;
                              return Promise.all(refreshingTokenholders);

                            case 3:
                              fetchingTokenholders = tokenholderAddresses.map(function (tokenholder) {
                                return factories.tokenholderFactory.fetch(entities_1.Tokenholder.generateId({
                                  securityTokenId: securityTokenId,
                                  address: tokenholder
                                }));
                              });
                              return _context.abrupt("return", Promise.all(fetchingTokenholders));

                            case 5:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));
                  }]
                })({
                  investors: tokenholderAddresses,
                  canSendAfter: canSendAfter,
                  canReceiveAfter: canReceiveAfter,
                  expiryTime: expiryTime
                });

              case 34:
                _ref2 = _context2.sent;
                _ref3 = _slicedToArray(_ref2, 1);
                revokedTokenholders = _ref3[0];
                return _context2.abrupt("return", revokedTokenholders);

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 9]]);
      }));
    }
  }]);

  return RevokeKyc;
}(Procedure_1.Procedure);

exports.RevokeKyc = RevokeKyc;